
export { WinNow, WinNowMarketing };

// Module for handling all WinNow functionality
var WinNow = (function () {

	var init = function () {
		// show the introduction video?  or a splash div?
		$("#winnow_container .video_1").show();

		$("#winnow_container .contents ol li").on("click", function () {
			var index = $(this).index() + 1;

			// does the video exist?
			if (!$("#winnow_container .video" + "_" + index)) {
				alert("Sorry, that content doesn't appear to be available. Please contact support@rotate123.com.");
				return;
			}

			// hide all videos
			$("#winnow_container .video").hide();

			// show the selected video
			$("#winnow_container .video" + "_" + index).show();
		});
	};

	return {
		init: init
	};

})();

// Module for handling all WinNow marketing functionality
var WinNowMarketing = (function () {

	var init = function () {

		$("#winnow_buy").on("click", function () {
			window.location = "/reg/subscribe";
		});
	};

	return {
		init: init
	};

})();



